import { render, staticRenderFns } from "./MamOrderHistoryScreen.vue?vue&type=template&id=595556f8&scoped=true"
import script from "./MamOrderHistoryScreen.vue?vue&type=script&lang=js"
export * from "./MamOrderHistoryScreen.vue?vue&type=script&lang=js"
import style0 from "./MamOrderHistoryScreen.vue?vue&type=style&index=0&id=595556f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595556f8",
  null
  
)

export default component.exports